import React, { useState, useEffect } from "react";
import DataParser from "../../utlits/Dataparser";
import { message } from "antd";
import Select from "react-select";

const LeadPendingField = (props) => {
  const { item, Status, Services, data, DefaultStatus, getCustomColor } = props;
  const [DefaultStatuss, setDefaultStatus] = useState(DefaultStatus);
  useEffect(() => {
    setDefaultStatus(DefaultStatus);
  }, [item]);

  // const handelChange = (e) => {
  //   e.preventDefault();
  //   setDefaultStatus(e.target.value);
  //   const id = item.id;
  //   const companyId = DataParser.CompanyId();
  //   const companyIdentifier = DataParser.CompanyIdentifier();
  //   const dataLead = {
  //     company_id: companyId,
  //     company_identifier: companyIdentifier,
  //     status: e.target.value,
  //   };
  //   Services(id, dataLead).then((res) => {
  //     data(e);
  //   });
  // };

  const handelChange = (e) => {
    e.preventDefault();
    const previousValue = DefaultStatuss; // old value
    setDefaultStatus(e.target.value);

    const id = item.id;
    const companyId = DataParser.CompanyId();
    const companyIdentifier = DataParser.CompanyIdentifier();
    const dataLead = {
      company_id: companyId,
      company_identifier: companyIdentifier,
      status: e.target.value,
    };

    Services(id, dataLead)
      .then((res) => {
        // Agar backend ne 2xx + Good: false bheja
        if (res.Good) {
          // Check for specific "approval required" message even if Good is true
          if (res.data && typeof res.data === 'string' && res.data.toLowerCase().includes("approval is required")) {
            message.warning(res.data);
            setDefaultStatus(previousValue);
          } else {
            message.success(typeof res.data === 'string' ? res.data : "Updated successfully");
            data(e);
          }
        } else {
          message.error(res.data);
          setDefaultStatus(previousValue);
        }
      })
      .catch((err) => {
        console.error(err);

        // Axios error object me response data hoti hai
        if (err.response && err.response.data) {
          message.error(err.response.data.data || "Status update failed");
        } else {
          message.error("Server error while updating status");
        }

        setDefaultStatus(previousValue);
      });
  };

  const getStatusConfig = (status) => {
    switch (status) {
      case "Complete":
      case "Completed":
        return { color: "#1CB333", bg: "#eafbec" };
      case "Pending":
        return { color: "#DFA70D", bg: "#fef7e0" };
      case "In Progress":
      case "In-Progress":
        return { color: "#607EF9", bg: "#eef0fe" };
      case "On Hold":
      case "On-Hold":
        return { color: "#0DDFAB", bg: "#e0fdf8" };
      case "Pending-Approval":
      case "Pending Approval":
        return { color: "#1D1D1D", bg: "#ebebeb" };
      case "Rejected":
        return { color: "#FF0000", bg: "#ffebeb" };
      case "Planning":
        return { color: "#4b5563", bg: "#f3f4f6" };
      case "Abandoned":
        return { color: "#ef4444", bg: "#fee2e2" };
      default:
        return { color: "#404e67", bg: "transparent" };
    }
  };

  const statusStyles = {
    control: (provided, state) => {
      const config = getStatusConfig(DefaultStatuss);
      return {
        ...provided,
        backgroundColor: config.bg,
        border: "none",
        minHeight: "28px",
        height: "28px",
        width: "100%",
        boxShadow: "none",
        cursor: "pointer",
        borderRadius: "5px",
        fontSize: props.fontSize || "11px",
        fontWeight: "600",
        "&:hover": {
          border: "none",
        },
      };
    },
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
      height: "28px",
    }),
    singleValue: (provided) => {
      const config = getStatusConfig(DefaultStatuss);
      return {
        ...provided,
        color: config.color,
        margin: 0,
      };
    },
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "28px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 4px",
      color: getStatusConfig(DefaultStatuss).color,
      "&:hover": {
        color: getStatusConfig(DefaultStatuss).color,
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 1000000 }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000000,
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      border: "1px solid #eee",
    }),
    option: (provided, state) => {
      const config = getStatusConfig(state.data.value);
      return {
        ...provided,
        backgroundColor: state.isFocused ? "#f8f9fa" : "#fff",
        color: config.color,
        fontSize: props.fontSize || "12px",
        fontWeight: "600",
        cursor: "pointer",
        padding: "8px 12px",
        "&:active": {
          backgroundColor: "#e9ecef",
        },
      };
    },
  };

  return (
    <>
      <div className="form-group align-items-center position-relative" style={{ width: "100%" }}>
        <Select
          styles={statusStyles}
          value={{ value: DefaultStatuss, label: DefaultStatuss }}
          options={(Status || [])
            .filter((el) => el !== "Pending-Approval" || DefaultStatuss === "Pending-Approval")
            .map(el => ({ value: el, label: el }))
          }
          onChange={(option) => {
            if (option) {
              const e = { target: { value: option.value }, preventDefault: () => {} };
              handelChange(e);
            }
          }}
          isDisabled={props.disabled}
          isSearchable={false}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </div>
    </>
  );
};

export default LeadPendingField;
